/**
 * LogoutSidebarNavigationItemButton
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Selectors
import { makeSelectUsersMePersonValue } from 'services/usersMe/selectors';

// Actions
// @ts-ignore
import { resetState } from '../../../../../../services/auth/actions';

// Components
// @ts-ignore
import SidebarNavigationItemButton from '../SidebarNavigationItemButton';

interface ConnectedProps {
    usersMeFirstName: string;
}
interface DispatchProps {
    resetState: Function;
}

type Props = ConnectedProps & DispatchProps;

export class LogoutSidebarNavigationItemButtonComponent extends React.PureComponent<Props> {
    handleClick = (): void => {
        this.props.resetState();
    };

    render(): React.ReactElement<Props> {
        const { usersMeFirstName } = this.props;
        const nameField = usersMeFirstName ? ` (${usersMeFirstName})` : '';

        return (
            <SidebarNavigationItemButton
                onClick={this.handleClick}
                title={`Logout${nameField}`}
                iconName="FiUser"
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    usersMeFirstName: makeSelectUsersMePersonValue('firstName')
});

export default connect(mapStateToProps, { resetState })(
    LogoutSidebarNavigationItemButtonComponent
);
